export default "__VITE_ASSET__DqZbGs8F__"